export const WALLET_CARD_IMAGE_PATH = '/image/wallet_card_background.svg';
export const WALLET_SIM_IMAGE_PATH = '/image/sim_card_icon.svg';

export const WALLET_BALANCE_API_URL = 'r/payment/accounting/v1/wallet/balance';
export const WALLET_CHARGE_API_URL = 'r/payment/accounting/v1/wallet/charge';
